<template>
  <v-container class="column-button-group">
    <v-row v-for="(row, rowIdx) in rows" class="button-group-row">
      <v-col :cols="Math.floor(12/cols)" v-for="(button,itemIdx) in row" :key="button.id" @click="onSelected(button.id)" class="button-item"
             :class="{
            'selected': button.id === selected,
            'top': rowIdx === 0,
            'left': itemIdx === 0,
            'bottom': rowIdx === rows.length - 1,
            'right': itemIdx === row.length - 1,
            'disabled': button.disabled
            }">
        {{button.label}}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
name: "VcColumnButtonGroup",
  props:{
    buttons: {
      type: Array,
      required: true,
      validator: function(buttons) {
        return buttons.every((button) => !!button.id && !!button.label)
      }
    },
    cols: {
      type: Number,
      default: 2
    },
    selected: String,
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  created() {
    this.buttonSelected = this.selected
  },
  data(){
    return{
      buttonSelected: false
    }
  },
  computed:
    {
    rows(){
      let rows = []
      for (let row = 0 ; row < Math.ceil(this.buttons.length / this.cols) ; row++){
        rows.push(this.buttons.slice(row * this.cols, row * this.cols + this.cols))
      }
      return rows
    }
  },
  methods: {
    onSelected: function(id){
      this.$emit('change', id)
    }
  }
}

</script>

<style scoped  lang="scss">
.column-button-group {
  font-family: var(--primary-font-family);
  font-weight: 500;
  font-size: 13px;

  .button-group-row {
    margin: 0;
  }

  .button-item{
    text-align: center;
    cursor: pointer;
    transition: 0.3s background-color, color ease-out;
    min-height: 40px;
    border-color: #D6DBE6;
    border-style: solid;
    border-width: 0;
    color: rgba(0, 0, 0, 0.62);
    border-top-width: 0;
    border-right-width: 1px;
    border-bottom-width: 1px;
    &.left{
      border-left-width: 1px;
    }
    &.top{
      border-top-width: 1px;
    }
    &.bottom:not(.top):not(.selected){
      border-top-width: 0;
    }
    &.top.left{
      border-top-left-radius: 6px;
    }
    &.top.right{
      border-top-right-radius: 6px;
    }
    &.bottom.left{
      border-bottom-left-radius: 6px;
    }
    &.bottom.right{
      border-bottom-right-radius: 6px;
    }
    &:hover{
      background-color: rgba(0, 0, 0, 0.03);
    }
    &:focus{
      box-shadow: 0px 0px 0px 3px rgba(var(--brand-color-secondary-rgb), 0.4);
    }
    &.selected{
      border: 2px solid var(--brand-color-secondary);
      font-weight: 600;
      &:hover{
        background: rgba(0, 0, 0, 0.03);
      }
    }
    &:active{
      background: rgba(0, 0, 0, 0.12);
    }
    &.disabled{
      background: rgba(0, 0, 0, 0.07);
      color: rgba(0, 0, 0, 0.4);
      pointer-events: none;
    }
  }
}
</style>
